import {
  getTheme
} from "./chunk-TXCBKCEB.js";
import {
  ErrorBoundary
} from "./chunk-LHUNKLMU.js";
import {
  DefaultAppLayoutProvider
} from "./chunk-BDRB3LP3.js";

// src/components/VarnishApp.tsx
import { CssBaseline, ThemeProvider } from "@mui/material";
import { jsx, jsxs } from "react/jsx-runtime";
function VarnishApp({ layout, theme, children }) {
  const mergedTheme = getTheme(theme);
  return /* @__PURE__ */ jsxs(ThemeProvider, { theme: mergedTheme, children: [
    /* @__PURE__ */ jsx(CssBaseline, {}),
    /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(DefaultAppLayoutProvider, { layout: layout || "center-aligned", children }) })
  ] });
}
var VarnishApp_default = VarnishApp;

export {
  VarnishApp,
  VarnishApp_default
};
//# sourceMappingURL=chunk-JBUNFPFF.js.map